/**
 * WooCommerce
 *
 */
import WooCheckout from "./woocommerce/checkout";
import WooFavourite from "./woocommerce/favourite";
import MobileFilterTrigger from "./woocommerce/mobileFilterTrigger";
import Filters from "./woocommerce/filters";
import Render from "./woocommerce/render";
import handleTaxToggle from "./woocommerce/taxToggle";
import { WooBasketBuilder } from "./woocommerce/basketBuilder";

window.addEventListener("DOMContentLoaded", () => {
	WooBasketBuilder();
	WooCheckout();
	WooFavourite();
	MobileFilterTrigger();
	new Filters(); // Init the filters
	handleTaxToggle();
	new Render(); // Init the renderer for status and notification
});

/**
 * Non WooCommerce
 *
 */
import Accordions from "./accordions";
import Scroll from "./animations/scroll";
import Heights from "./matchHeight";
import Sliders from "./sliders";
import Filter from "./filters";
import Menu from "./menu";
import Tabs from "./tabs";
import Video from "./video";
import Search from "./search";
import Banner from "./banner";

window.addEventListener("DOMContentLoaded", () => {
	Heights();
	Sliders();
	Filter();
	Menu();
	Video();
	Search();
	Banner();

	new Scroll(
		document.querySelectorAll("[data-fade-in]"),
		{
			opacity: 0,
			top: 20,
			position: "relative",
		},
		{
			opacity: 1,
			top: 0,
			duration: 1,
		}
	);

	// Default Accordions
	const accordionSections = document.querySelectorAll("[data-accordions]");

	if (accordionSections.length) {
		accordionSections.forEach((accordions) => {
			new Accordions(accordions, "[data-accordion]", true);
		});
	}

	// Filter Accordions
	const filterAccordions = document.querySelectorAll("[data-filters]");

	if (filterAccordions.length) {
		filterAccordions.forEach((accordions) => {
			new Accordions(accordions, "[data-accordion]", false);
		});
	}

	// Default Tabs
	const tabs = document.querySelectorAll("[data-tabs]");

	if (tabs.length) {
		tabs.forEach((tab) => {
			new Tabs(tab);
		});
	}

	const sizeTables = document.querySelectorAll(".size-table");

	if (sizeTables.length) {
		sizeTables.forEach((table) => {
			const wrapper = document.createElement("div");
			wrapper.classList.add("size-table-wrapper");
			table.parentNode.insertBefore(wrapper, table);
			wrapper.appendChild(table);
		});
	}

	const moveWooFee = () => {
		const fees = document.querySelectorAll(".fee");
		const wooItems = document.querySelectorAll(".cart_item");

		if (fees.length && wooItems.length) {
			// move fees into the bellow the last wooItem
			wooItems[wooItems.length - 1].parentNode.insertBefore(
				fees[0],
				wooItems[wooItems.length - 1].nextSibling
			);
		}
	};
	moveWooFee();

	jQuery("body").on("updated_cart_totals", function () {
		moveWooFee();
	});

	jQuery("body").on("updated_cart_totals", function () {
		setTimeout(() => {
			location.reload();
		}, 1000);
	});
});
